import ConfirmDialog from '@/components/modals/confirm-dialog.vue'
import eventBus, { eventNames } from '@/lib/eventBus'

/** Consistent, non-blocking feedback for operator actions. */
export default {
  methods: {
    showConfirmationDialog ({ message, headerText = null, action = 'update', onConfirm }) {
      this.$modal.show(
        ConfirmDialog,
        { message, headerText, action, onConfirm },
        { height: 'auto', scrollable: true }
      )
    },

    showNotification (type, text, time) {
      eventBus.$emit(eventNames.SHOW_SNACKBAR, { type, text, time })
    }
  }
}
